import { Action, Reducer } from "redux";
import {
	IntegrationQueueStatusState,
	IntegrationQueueStatusTypes,
	IntegrationQueueStatusActionTypes,
} from "./integrationQueueStatusTypes";

export const INITIAL_STATE: IntegrationQueueStatusState = {
	integrationQueueStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const integrationQueueStatusReducer: Reducer<IntegrationQueueStatusState> = (
	state: IntegrationQueueStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as IntegrationQueueStatusActionTypes;
	switch (actionTypes.type) {
		case IntegrationQueueStatusTypes.GET_INTEGRATION_QUEUE_STATUS:
			return {
				...state,
				integrationQueueStatus: {
					...state.integrationQueueStatus,
					isLoading: true,
				},
			};
		case IntegrationQueueStatusTypes.SAVE_INTEGRATION_QUEUE_STATUS:
			return {
				...state,
				integrationQueueStatus: {
					...state.integrationQueueStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationQueueStatusTypes.RESET_REDUCER_INTEGRATION_QUEUE_STATUS:
			return {
				...state,
				integrationQueueStatus: INITIAL_STATE.integrationQueueStatus,
			};
		default:
			return state;
	}
};

export default integrationQueueStatusReducer;
